import React, { useState, useEffect } from 'react';

import ServiceOverview from 'services/serviceOverview';
import Skeleton from 'react-loading-skeleton';

export default function ComponentListBookingPMode(props) {

    const overviewService = new ServiceOverview();

    const [chartData, setChartData] = useState({
        "UPI": 0,
        "CASH": 0,
        "Online": 0,
        "Regular": 0,
        "Website": 0,
        "GoMMT": 0,
        "OYO Paid": 0,
        "Booking.com": 0,
        "Agoda": 0
    });

    const [loading, setLoading] = useState(true);

    const loadData = () => {
        (async function () {
            if (props.range !== undefined && props.range.from !== undefined && props.range.to !== undefined) {
                let body = {
                    "startDate": props.range.from.toISOString(),
                    "endDate": props.range.to.toISOString(),
                }
                var res = await overviewService.getTransactionChartData(body, '');
                setChartData(res.data);
            }
            setLoading(false);
        })();
    }

    useEffect(() => {
        setLoading(true);
        loadData();
    }, [props.range]);

    return (
        <div className='col-span-4'>
            <div className="shadow bg-white rounded-lg p-4">
                <div className='flex items-center justify-between'>
                    <h3 className='text-lg font-sans font-medium'>Booking Sales | Payment Mode</h3>
                </div>
                <hr className='my-2' />
                {
                    loading ? <Skeleton count={5} /> :
                        <>
                            <div className='mb-4'>
                                <h4 className='text-xs font-bold text-gray-500 uppercase tracking-wider mb-2'>Payments</h4>
                                <div className='grid grid-cols-2 gap-2'>
                                    {
                                        ["CASH", "UPI", "Online", "Regular", "Website"].map(mode => (
                                            <div key={mode} className="rounded-lg border bg-card text-card-foreground shadow-sm p-3">
                                                <div className="flex flex-row items-center justify-between pb-1">
                                                    <div className="text-xs font-medium text-gray-600">{mode}</div>
                                                </div>
                                                <div className="text-lg font-bold text-blue-600">₹ {(chartData[mode] || 0).toFixed(2)}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div>
                                <h4 className='text-xs font-bold text-gray-500 uppercase tracking-wider mb-2'>Third Party Receivables</h4>
                                <div className='grid grid-cols-2 gap-2'>
                                    {
                                        ["GoMMT", "OYO Paid", "Booking.com", "Agoda"].map(mode => (
                                            <div key={mode} className="rounded-lg border bg-card text-card-foreground shadow-sm p-3">
                                                <div className="flex flex-row items-center justify-between pb-1">
                                                    <div className="text-xs font-medium text-gray-600">{mode}</div>
                                                </div>
                                                <div className="text-lg font-bold text-purple-600">₹ {(chartData[mode] || 0).toFixed(2)}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </>
                }
            </div>
        </div>
    )
}
